module.exports = __webpack_public_path__ + "img/Boucherie.966a1fea.jpg";